export default __webpack_public_path__ + "favicon-4e20a9a1662b0305dd0eaffc11caf73d.bundle.png";